import type { DateRange } from "react-day-picker";

export type DateRangeTuple = [Date | null, Date | null];

export function tupleToDateRange(
  tuple: DateRangeTuple
): DateRange | undefined {
  const [from, to] = tuple;
  if (from == null && to == null) return undefined;
  return { from: from ?? undefined, to: to ?? undefined };
}

export function dateRangeToTuple(
  range: DateRange | undefined
): DateRangeTuple {
  if (!range?.from && !range?.to) return [null, null];
  return [range.from ?? null, range.to ?? null];
}
